import { render } from "./botUI.vue?vue&type=template&id=280f7c0b&scoped=true"
import script from "./botUI.vue?vue&type=script&lang=js"
export * from "./botUI.vue?vue&type=script&lang=js"

import "./botUI.vue?vue&type=style&index=0&id=280f7c0b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280f7c0b"]])

export default __exports__